import type { ModuleManifest } from "./types";

export const threatsManifest: ModuleManifest = {
  name: "threats",
  label: "Minaccia",
  labelPlural: "Minacce",
  coreBOSModule: "Threats",
  wsidPrefix: "69x",
  type: "standard",
  routes: {
    list: "/threats",
    show: "/threats/show/:id",
    create: "/threats/create",
    edit: "/threats/edit/:id",
  },
  navigation: {
    icon: "WarningOutlined",
    order: 11,
    group: "Security",
  },
  routing: {
    keywords: ["threat", "threats", "minaccia", "minacce", "rischio"],
    searchFields: ["threatsname"],
    defaultSort: { field: "threatsname", order: "asc" },
  },
  context: { supported: true, entityKey: "threats" },
  fields: [
    { name: "threatsname", label: "Nome Minaccia", type: "string", required: true },
    { name: "threat_id", label: "Codice", type: "string" },
    { name: "thriskscore", label: "Risk Score", type: "number" },
    { name: "category", label: "Categoria", type: "picklist" },
    { name: "type_of_threats", label: "Tipo", type: "picklist" },
    { name: "company", label: "Account", type: "reference" },
    { name: "description", label: "Descrizione", type: "text" },
    { name: "assigned_user_id", label: "Assegnato a", type: "reference" },
  ],
  relationships: [
    { module: "Accounts", field: "company", label: "Account", icon: "BankOutlined", displayField: "accountname" },
    { module: "ThreatsMeasures", relation: "one-to-many", field: "threat_link", label: "Minacce-Misure", icon: "SafetyOutlined", displayField: "threatsmeasuresname" },
  ],
  requiredFields: ["threatsname"],
  viewStrategy: "bespoke",
};
